import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../components/Logo';
import { Button } from '../../components/Ui';
import { storage } from '../../api/client';
import { colors } from '../../theme';

const ONBOARDED_KEY = 'kw_onboarded';

const SLIDES = [
  {
    key: '1',
    emoji: '🛠️',
    title: 'Every local service,\none place',
    text: 'Electrician, plumber, cleaning, salon, gym, groceries, cabs, jobs — book what you need from people near you.',
    color: colors.primary,
  },
  {
    key: '2',
    emoji: '⚡',
    title: 'Book · Track ·\nGet it done',
    text: 'Pick a slot, track your order or booking live, and pay online or on delivery. No phone tag.',
    color: colors.accent,
  },
  {
    key: '3',
    emoji: '🏪',
    title: 'Grow your\nbusiness too',
    text: 'Shops, professionals and drivers can join as partners, list their work and receive orders directly.',
    color: '#16A34A',
  },
];

const OnboardingPage = () => {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);

  const finish = () => {
    storage.set(ONBOARDED_KEY, '1');
    navigate('/get-started', { replace: true });
  };

  const next = () => {
    if (index >= SLIDES.length - 1) finish();
    else setIndex((i) => i + 1);
  };

  const slide = SLIDES[index];

  return (
    <div style={{ minHeight: '100vh', background: '#fff', display: 'flex', flexDirection: 'column' }}>
      <div className="row-between" style={{ padding: '18px 22px' }}>
        <Logo size={40} />
        <button type="button" className="link-btn" style={{ color: colors.muted }} onClick={finish}>
          Skip
        </button>
      </div>

      <div
        className="grow"
        style={{
          display: 'grid', placeItems: 'center', padding: '20px 24px', textAlign: 'center',
        }}
      >
        <div key={slide.key} style={{ maxWidth: 460 }}>
          <div
            className="pop"
            style={{
              width: 216, height: 216, borderRadius: '50%', margin: '0 auto 28px',
              background: `${slide.color}14`, display: 'grid', placeItems: 'center', fontSize: 84,
            }}
          >
            {slide.emoji}
          </div>
          <h1 className="h1 reveal" style={{ fontSize: 27, lineHeight: 1.3, whiteSpace: 'pre-line' }}>
            {slide.title}
          </h1>
          <p className="t-body reveal" style={{ color: colors.muted, marginTop: 12, lineHeight: 1.6, animationDelay: '70ms' }}>
            {slide.text}
          </p>
        </div>
      </div>

      <div className="row" style={{ justifyContent: 'center', gap: 6, marginBottom: 22 }}>
        {SLIDES.map((s, i) => (
          <button
            key={s.key}
            type="button"
            aria-label={`Go to slide ${i + 1}`}
            onClick={() => setIndex(i)}
            style={{
              width: i === index ? 26 : 8, height: 8, borderRadius: 4, border: 0,
              background: colors.primary, opacity: i === index ? 1 : 0.3,
              transition: 'width .26s cubic-bezier(.22,1,.36,1), opacity .26s ease',
            }}
          />
        ))}
      </div>

      <div style={{ padding: '0 22px 30px', maxWidth: 460, margin: '0 auto', width: '100%' }}>
        <Button
          title={index === SLIDES.length - 1 ? 'Get started' : 'Next'}
          icon={index === SLIDES.length - 1 ? '⚡' : null}
          onClick={next}
          size="lg"
          full
        />
      </div>
    </div>
  );
};

export default OnboardingPage;
